import './IntegrationView.scss';

export { default } from './IntegrationView';
